var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"border-radius":"6px","padding":"8px 8px 8px 4px"}},[_c('Doughnut',{staticStyle:{"height":"250px"},attrs:{"chart-options":_vm.chartOptions,"chart-data":_vm.chartData,"chart-id":_vm.chartId,"dataset-id-key":_vm.datasetIdKey}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }